// extracted by mini-css-extract-plugin
export default {"landing":"Landing_landing__pC9WW","btn":"Landing_btn__uOqVl","logo":"Landing_logo__097fN"};